var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',[_c('i',{staticClass:"icon icon-checkmark"})]):_c('span',{staticClass:"text-muted"},[_vm._v("\n  —\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }